// extracted by mini-css-extract-plugin
var _1 = "fVt_TEysnvBM5Sc_jAcA";
export { _1 as "flow-mo-completed" }
